import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PromoCodeBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PromoCodeComponent extends PromoCodeBaseComponent {}
